import { render, staticRenderFns } from "./AddEntriesToTerminalBatchForm.vue?vue&type=template&id=22f26e3c&scoped=true&"
import script from "./AddEntriesToTerminalBatchForm.vue?vue&type=script&lang=js&"
export * from "./AddEntriesToTerminalBatchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f26e3c",
  null
  
)

export default component.exports